import makeStyles from '@material-ui/core/styles/makeStyles';

export const useHighlightingStyles = makeStyles((theme) => ({
    annotatedText: {
        color: theme.palette.text.primary,

        '& em, & fuzzy': {
            fontWeight: 500,
            textDecoration: 'none',
            fontStyle: 'normal',
        },

        // For complete matches. They are displayed in an <em> tag.
        '& em': {
            backgroundColor: theme.palette.type === 'light' ? '#ffff9b' : '#6d335e',
        },

        // For fuzzy matches. They are displayed in a <fuzzy> tag.
        '& fuzzy': {
            backgroundColor: theme.palette.type === 'light' ? '#e6e6e6' : '#cacaca',
        },
    },
}));
